import React, { createContext, useContext } from "react";

import type { MarketingPortalProviderProps } from "./types";

const MarketingPortalContext = createContext<string>("");

export const MarketingPortalProvider: React.FC<
  MarketingPortalProviderProps
> = ({ children, marketingPortal }) => {
  return (
    <MarketingPortalContext.Provider value={marketingPortal}>
      {children}
    </MarketingPortalContext.Provider>
  );
};

export const useMarketingPortal = (): string => {
  return useContext(MarketingPortalContext);
};
